export const BOOK_TITLE = 'Money Skills for Your Twenties';
export const BOOK_SUBTITLE = 'A Judgment-Free Guide to Credit, Debt, and Feeling Steady with Money';
export const BOOK_SUBTITLE_SHORT = 'A Judgment-Free Guide to Money';
export const BOOK_AUTHOR = 'Abraham Cuenca';
export const BOOK_PRICE = 4.99;
export const BOOK_PRICE_DISPLAY = '$4.99';
export const PAPERBACK_PRICE = 17.99;
export const PAPERBACK_PRICE_DISPLAY = '$17.99';
export const PAPERBACK_AMAZON_URL = 'https://www.amazon.com/dp/B0GXRX5Q2L';
export const EBOOK_AMAZON_URL = 'https://www.amazon.com/dp/B0GX371XNH';

// Flip to false once the title exits the KDP Select (Kindle exclusivity) program.
// When true: eBook purchases route to Amazon Kindle, and on-site checkout + redeem
// flows are hidden. When false: the original Square checkout and redeem code flows return.
export const KINDLE_SELECT_MODE = true;
export const BOOK_DESCRIPTION =
  'A judgment-free guide to credit, debt, and feeling steady with money. Written for real life in your twenties, not a spreadsheet version of you. You\'re not bad with money. You were never taught the rules.';

export const SITE_URL = 'https://moneyskillsbook.com';
